import { useState, useEffect } from "react";
import Sidebar from "../components/sidebar";
import { Card, Row, Col } from "react-bootstrap";
import axios from 'axios';
import portadacirp from "../assets/video/portada.png";
import logohorcirp from "../assets/img/lodohorcirp.jpg";
import { FaUsers, FaHandshake } from "react-icons/fa";

const url = "https://api.mrcirp.com/public/leads";
const videoApiUrl = "https://api.mrcirp.com/public/videos";

const Iniciouser = () => {
  const [data, setData] = useState([]);
  const [users, setUsers] = useState({});
  const [videoEnded, setVideoEnded] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);
  const [stats, setStats] = useState({
    leads: 0,
    referidos: 12,
    ganancias: 850,
    invitaciones: 24,
    efectivas: 15
  });

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem('loginUser');
    if (loginUserJSON) {
      const user = JSON.parse(loginUserJSON);
      setUsers(user);
    }
  }, []);
  
  useEffect(() => {
    if (users.id) {
      peticionGet();
      fetchVideoData();
      setStats(prev => ({...prev, leads: data.length}));
    }
  }, [users, data.length]);

  const peticionGet = async () => {
    try {
      const response = await axios.get(`${url}/${users.id}`);
      setData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchVideoData = async () => {
    try {
      const response = await axios.get(videoApiUrl);
      // Asumimos que la API devuelve un array y tomamos el primer elemento
      const video = response.data[0];
      setVideoUrl(video.urlvideo);
    } catch (error) {
      console.error("Error fetching video data:", error);
    }
  };

  const handleVideoEnded = () => {
    setVideoEnded(true);
  };

  const renderVideoPlayer = () => {
    if (!videoUrl) return <div>Cargando video...</div>;
    
    // Verificamos si es una URL de YouTube
    if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
      let videoId = '';
      
      // Extraemos el ID del video de YouTube
      if (videoUrl.includes('v=')) {
        videoId = videoUrl.split('v=')[1].split('&')[0];
      } else if (videoUrl.includes('youtu.be/')) {
        videoId = videoUrl.split('youtu.be/')[1].split('?')[0];
      }
      
      return (
        <iframe
          width="100%"
          height="400"
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Video CIRP"
        ></iframe>
      );
    }
    
    // Verificamos si es una URL de Vimeo
    if (videoUrl.includes('vimeo.com')) {
      const videoId = videoUrl.split('vimeo.com/')[1].split('?')[0];
      
      return (
        <iframe
          src={`https://player.vimeo.com/video/${videoId}?autoplay=1`}
          width="100%"
          height="400"
          frameBorder="0"
          allow="autoplay; fullscreen"
          allowFullScreen
          title="Video CIRP"
        ></iframe>
      );
    }
    
    // Si no es YouTube ni Vimeo, asumimos que es un MP4 directo
    return (
      <video
        width="100%"
        controls
        autoPlay
        poster={portadacirp}
        onEnded={handleVideoEnded}
      >
        <source src={videoUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    );
  };

  const efectividad = stats.invitaciones > 0 
    ? (stats.efectivas / stats.invitaciones) * 100 
    : 0;

  return (
    <div>
      <Sidebar>
        <div className="container-fluid mt-4 mb-5">
          <Row className="mb-4">
            <Col>
              <h2>Bienvenido, {users.nombre || 'Usuario'}</h2>
              <p className="text-muted">Resumen de tu actividad en la plataforma</p>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col lg={8}>
              <Card className="shadow-sm">
                <Card.Body className="p-0">
                  {!videoEnded ? (
                    renderVideoPlayer()
                  ) : (
                    <img src={logohorcirp} alt="Logo CIRP" width="100%" />
                  )}
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4}>
              <Row>
                <Col md={6} lg={12} className="mb-3">
                  <Card className="h-100 shadow-sm">
                    <Card.Body>
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <h6 className="text-muted mb-2">Leads Captados</h6>
                          <h3>{stats.leads}</h3>
                        </div>
                        <div className="bg-info bg-opacity-10 p-3 rounded">
                          <FaHandshake size={24} className="text-info" />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                
                <Col md={6} lg={12} className="mb-3">
                  <Card className="h-100 shadow-sm">
                    <Card.Body>
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <h6 className="text-muted mb-2">Clientes Referidos</h6>
                          <h3>{stats.referidos}</h3>
                          <small className="text-muted">{stats.efectivas} efectivos</small>
                        </div>
                        <div className="bg-primary bg-opacity-10 p-3 rounded">
                          <FaUsers size={24} className="text-primary" />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Sidebar>
      
      <Footer />
    </div>
  );
};

const Footer = () => (
  <footer style={footerStyle}>
    <p>Copyright© 2024 - Benjamin Romero Corporación S.A. SJO Costa Rica - Todos los derechos reservados Ley 6683 Privacy Policy</p>
  </footer>
);

const footerStyle = {
  textAlign: 'center',
  padding: '7px',
  position: 'fixed',
  left: '0',
  bottom: '0',
  width: '100%',
  backgroundColor: '#f1f1f1',
  color: '#000',
};

export default Iniciouser;